import request from "../request";

/**
 * 登录后台系统。
 *
 * @param {object} data 登录表单。
 * @returns {Promise<object>} 登录后的用户上下文。
 */
export const login = (data) => {
  return request({
    url: "/auth/login",
    method: "POST",
    data,
  });
};

export const getLoginSecurity = (params) => {
  return request({
    url: "/auth/login/security",
    method: "GET",
    params,
  });
};

export const getCaptcha = (params) => {
  return request({
    url: "/auth/captcha",
    method: "GET",
    params,
  });
};

/**
 * 退出当前登录会话。
 *
 * @returns {Promise<void>} 退出结果。
 */
export const logout = () => {
  return request({
    url: "/auth/logout",
    method: "POST",
  });
};

/**
 * 获取当前登录用户信息。
 *
 * @returns {Promise<object>} 当前用户信息。
 */
export const getUserInfo = () => {
  return request({
    url: "/auth/me",
    method: "GET",
  });
};
